import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface StepCardProps {
  title: string;
  index: number;
  isLast: boolean;
}
function StepCard({
  title,
  index,
  isLast
}: StepCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <div className="relative flex-1" data-id="element-128">
      <motion.div ref={ref} className="relative z-10 p-8 rounded-3xl bg-white border-2 border-rose-100 shadow-xl text-center h-full flex items-center justify-center" initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.5,
      delay: index * 0.15
    }} data-id="element-129">
        <h3 className="text-xl sm:text-2xl font-bold text-slate-900" data-id="element-130">
          {title}
        </h3>
      </motion.div>

      {/* Connector arrow (hidden on last item and mobile) */}
      {!isLast && <div className="hidden lg:block absolute top-1/2 -right-6 transform -translate-y-1/2 z-0" data-id="element-131">
          <motion.div className="text-rose-300 text-4xl" initial={{
        opacity: 0,
        x: -10
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 0.3,
        delay: index * 0.15 + 0.3
      }} data-id="element-132">
            →
          </motion.div>
        </div>}
    </div>;
}
export function HowItWorks() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const steps = ['1️⃣ Compra el kit', '2️⃣ Descarga los archivos', '3️⃣ Imprime o vende los diseños'];
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-133">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <motion.div ref={headerRef} className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-135">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-136">
            ⚡ Cómo funciona
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500" data-id="element-137">
            3 pasos simples
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-6 lg:gap-12 mb-12" data-id="element-138">
          {steps.map((title, index) => <StepCard key={index} title={title} index={index} isLast={index === steps.length - 1} data-id="element-139" />)}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-140">
          <p className="text-2xl font-extrabold text-slate-800 mb-8" data-id="element-141">Listo.</p>
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-10 py-5 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-xl font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto" data-id="element-142">
            👉 Acceder al Mega Kit — $27.990 ARS
          </a>
        </motion.div>
      </div>
    </section>;
}